import React from 'react'

const Switch = ({ onChange }) => {
  return (
    <div>
      <label className='switch-component'>
        <input
          type='checkbox'
          onChange={(e) => {
            onChange(e)
          }}
        />
        <span className='slider round'></span>
      </label>
    </div>
  )
}

export default Switch
